export default (props, vars) => props?.['applicationStatus']?.job_name;
